const marks = new Map<string, number>()

export function markUx(name: string): void {
  marks.set(name, performance.now())
}

export function measureUx(name: string, start: string): number | null {
  const started = marks.get(start)
  if (started === undefined) return null
  const duration = performance.now() - started
  performance.measure(`ci:${name}`, { start: started, duration })
  return duration
}

export function measureUxOnce(
  name: string,
  start: string,
  maxAgeMs = 10_000,
): number | null {
  const started = marks.get(start)
  if (started === undefined) return null
  marks.delete(start)
  const duration = performance.now() - started
  if (duration > maxAgeMs) return null
  performance.measure(`ci:${name}`, { start: started, duration })
  return duration
}

export function observeCoreWebVitals(): void {
  if (!('PerformanceObserver' in window)) return
  const supported = PerformanceObserver.supportedEntryTypes
  if (supported.includes('longtask')) {
    const observer = new PerformanceObserver(() => undefined)
    observer.observe({ type: 'longtask', buffered: true })
  }
}
